"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CounterBadge: function() {
        return _index.CounterBadge;
    },
    counterBadgeClassNames: function() {
        return _index.counterBadgeClassNames;
    },
    useCounterBadgeStyles_unstable: function() {
        return _index.useCounterBadgeStyles_unstable;
    },
    useCounterBadge_unstable: function() {
        return _index.useCounterBadge_unstable;
    }
});
const _index = require("./components/CounterBadge/index");
